// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__D50ku","header":"Editor_header__w7nBM","codeMirrorWrapper":"Editor_codeMirrorWrapper__HH78f"};